'use client';

import { buildAppErrorCaptureProperties } from './app-error-context';
import {
  ensurePostHogBrowserInitialized,
  posthog,
} from './posthog-browser-client';

export const captureNextGlobalError = (
  error: Error & { digest?: string },
  pathname: string | null
): void => {
  if (!ensurePostHogBrowserInitialized()) return;
  posthog.captureException(error, {
    ...buildAppErrorCaptureProperties(
      error,
      pathname,
      'next_global_error_boundary'
    ),
    ...(error.digest ? { error_digest: error.digest } : {}),
  });
};
